import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentDetail: {
    id: 'comp.confirmPanel.paymentDetail',
    defaultMessage: 'Payment Details',
  },
  payYou: {
    id: 'comp.confirmPanel.payYou',
    defaultMessage: 'Total you pay',
  },
  confirm: {
    id: 'comp.confirmPanel.confirm',
    defaultMessage: 'Confirm',
  },
  amount: {
    id: 'comp.confirmPanel.amount',
    defaultMessage: 'Amount',
  },
  adminFee: {
    id: 'comp.confirmPanel.adminFee',
    defaultMessage: 'Admin Fee',
  },
  totalBill: {
    id: 'comp.confirmPanel.totalBill',
    defaultMessage: 'Total Bill',
  },
  estDate: {
    id: 'comp.confirmPanel.estDate',
    defaultMessage: 'Est. Processed Date',
  },
  paymentAmount: {
    id: 'comp.confirmPanel.paymentAmount',
    defaultMessage: 'Payment Amount',
  },
  titleNoBiller: {
    id: 'comp.confirmPanel.titleNoBiller',
    defaultMessage: 'Phone number is not registered',
  },
  descNoBiller: {
    id: 'comp.confirmPanel.descNoBiller',
    defaultMessage:
      "We're sorry, the phone number you entered is not registered on the digital money provider.Please check your phone number or the digital money provider that was chosen.",
  },
  closeBtn: {
    id: 'comp.confirmPanel.closeBtn',
    defaultMessage: 'Close',
  },
  changeBtn: {
    id: 'comp.confirmPanel.changeBtn',
    defaultMessage: 'Change',
  },
  paymentMethod: {
    id: 'comp.confirmPanel.paymentMethod',
    defaultMessage: 'Payment Method',
  },
  vaTarget: {
    id: 'comp.confirmPanel.vaDestination',
    defaultMessage: 'Virtual Account Destination',
  },

  tnc: {
    before: {
      id: 'tnc.before',
      defaultMessage: 'I agree with the ',
    },
    btn: {
      id: 'tnc',
      defaultMessage: 'Terms & Conditions',
    },
  },
});
